import React, { createRef, useState } from 'react'
import CloseIcon from '../images/close.svg'
import { Cropper } from 'react-cropper'
import "cropperjs/dist/cropper.css";

export default function AgentConfirmationPopup({type,activeData,onConfirm,setActiveData,onClose}) {
//console.log(activeData)

  return (
    <div className='bg-black bg-opacity-70 fixed z-[999] w-[100%] h-full left-0 top-0 flex justify-center items-center'>
    <div className='w-[95%] md:w-[480px] max-w-full bg-white   top-0 h-auto right-[320px] py-2 rounded-md'>
        <div className='flex px-8 py-4 justify-between items-center'>
            <h3 className='text-sm md:text-md font-semibold tracking-[-.15px]'>{type === 'feature' ? 'Feature Confirmation' : type==='reject' ? 'Reject Confirmation' : type === 'ban' ? 'Ban Agent Confirmation' : type === 'delete' || type === 'poc' ? 'Delete Confirmation' : 'Approve Confirmation'}</h3>
            <div className='bg-gray-100 px-2 py-2 rounded-md hover:bg-gray-200 transition-all cursor-pointer' onClick={()=>onClose(false)}>
              <img src={CloseIcon} className='w-4 h-4'/>
            </div>
        </div>
        <div className='flex px-4 py-2 md:px-8 md:py-4 pt-4 w-full '>
            <p className='text-[14px] md:text-sm text-black font-normal'>{type === 'feature' ? activeData.featured === 0 ? 'Are you sure want to feature?' : 'Are you sure want to remove from featured?' : type==='reject' ? 'Are you sure to reject?' : type ==='approve' ? 'Are you sure to approve?' : type === 'ban' ? 'Are you sure want to ban?' : type === 'delete' ? 'Are you sure want to delete?' : type==='poc' ?'Are you sure want to delete this point of contact?' : ''}{}</p>
        </div>
        <div className='flex mt-4 px-4 py-2 md:px-8 md:py-4 pt-4'>
            <button className='btn-md' type='button' onClick={()=>onConfirm(activeData.id)}>Yes</button>
            <button className='ml-4 btn-md-disabled' onClick={()=>onClose(false)}>No</button>
        </div>
    </div>
</div>
  )
}
